import Footer from '../../components/layouts/footer'
import {
    HorizontalMoreIcon,
    PlusIcon,
    StatuspageIoIcon,
    TrashIcon,
    EditIcon,
    StatusIoIcon,
    ZapierIcon,
    TrelloIcon,
    JiraIcon,
    ZendeskIcon,
    AnyDoIcon,
    WebhooksColoredIcon,
    GoogleCalendarIcon,
    PagerDutyIcon,
    PlayIcon,
    PausedIcon
} from '../../icons'
import {ImgButton} from '../../components/core/button'
import {PageSubTitle, PageTitle} from '../../components/core/title'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import ResponsivePageTitle from '../../components/core/title/ResponsivePageTitle'
import ContentLoader from '../../components/core/loader'
import Table from '../../components/core/table'
import AddIntegration from './addForms/addIntegration'
import EditIntegration from './updateForms/editIntegration'
import {setConfirmIsActive} from '../../stores/alert'
import Confirm from '../../components/core/confirm'
import Modal from '../../components/core/modal'
import EmptyComponent from './EmptyComponent'
import Dropdown from '../../components/core/dropdown'
import {MenuItem} from '@szhsin/react-menu'
import {deleteIntegration, getIntegrations, setCheckedIntegrations, setIntegrations, updateIntegraitonStatus} from '../../stores/integration'
import TextHelper from '../../utils/text'
import TeamSwitcher from '../../components/pages/teams'
import Customer from '../../utils/customer'
import INTEGRATION_TYPES from '../../data/integrationTypes.json'
import plans from '../../data/plans.json'
import {useSearchParams} from 'react-router-dom'
import AuthService from './../../api/auth'
import FormHelper from './../../utils/forms'
import AuthClient from './authForms'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {colors} from '../../utils/colors'
import IntegrationTeamMenu from '../../components/pages/IntegrationsTeamMenu'
import classNames from 'classnames'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'
import {envConfig} from '../../utils/env'

const {isReadOnlyModeEnabled} = envConfig

const integrationTypes = text => ({
    'statuspageIo': {
        'type': INTEGRATION_TYPES.types.statuspageIo,
        'text': text.statuspageIo,
        'icon': <StatuspageIoIcon/>
    },
    'zapier': {
        'type':  INTEGRATION_TYPES.types.zapier,
        'text': text.statuspageIo,
        'icon': <ZapierIcon/>
    },
    'statusIo': {
        'type': INTEGRATION_TYPES.types.statusIo,
        'text': text.statusIo,
        'icon': <StatusIoIcon/>
    }
})

const zapierTypeIcons = {
    zapier: <ZapierIcon />,
    zapier_trello: <TrelloIcon />,
    zapier_trello_cards: <TrelloIcon />,
    zapier_jira: <JiraIcon />,
    zapier_zendesk: <ZendeskIcon />,
    zapier_any_do: <AnyDoIcon />,
    zapier_webhooks: <WebhooksColoredIcon className="webhook-icon"/>,
    zapier_google_calendar: <GoogleCalendarIcon />,
    zapier_pagerduty: <PagerDutyIcon />
}

const Integrations = () => {
    const dispatch = useDispatch()
    const text = useNamespaceTranslations('integrations')
    const allIntegrationTypes = integrationTypes(text)
    const integrations = useSelector(state => state.integrations.integrations)
    const checkedIntegrations = useSelector(state => state.integrations.checkedIntegrations)
    const checkedIntegration = integrations.find(integration =>
        checkedIntegrations.length &&
        integration.integration_id === checkedIntegrations[0] ||
        integration.provider_id === checkedIntegrations[0]
    )
    const isDeleting = useSelector(state => state.integrations.isDeleting)
    const isFetching = useSelector(state => state.integrations.isFetching)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const [isNewIntegrationModalActive, setIsNewIntegrationModalActive] = useState(false)
    const [isEditIntegrationModalActive, setIsEditIntegrationModalActive] = useState(false)
    const [clickedIntegration, setClickedIntegration] = useState(null)
    const [clientData, setClientData] = useState({})
    const [isSelectedIntegrationZapier, setIsSelectedIntegrationZapier] = useState(false)
    const [isOauthModalActive, setIsOauthModalActive] = useState(false)
    const [isProgressing, setIsProgressing] = useState(false)
    const [type, setType] = useState(null)
    const [searchParams] = useSearchParams()
    const clientId = searchParams.get('client_id')
    const redirectUri = searchParams.get('redirect_uri')
    const state = searchParams.get('state')
    const responseType = searchParams.get('response_type')
    const scopes = searchParams.get('scope')?.split(',')
    const tableHeader = [
        {
            label: text.status,
            className: 'min-width-150'
        },
        {
            label: text.name,
            className: 'min-width-150'
        },
        {
            label:text.type,
            className: 'min-width-150'
        },
        {
            label: 'ID',
            className: 'min-width-300'
        },
        {
            label: 'Api ID',
            className: 'min-width-150'
        },
        {
            label: 'Api key',
            className: 'flex-1'
        }
    ]

    const currentPlan = localStorage.getItem('plan')
    const isIntegrationDisabled = currentPlan === plans.free_v1.key || currentPlan === plans.free_v2.key || currentPlan === plans.developer_v1.key
    const tbodyData = []

    const isTypeSelected = Object.values(INTEGRATION_TYPES.types).includes(type)

    const integrationElement = (name, icon, type) => {
        return {name, icon, type}
    }

    const integrationOptions = [
        integrationElement('Statuspage.io', <StatuspageIoIcon />, INTEGRATION_TYPES.types.statuspageIo),
        integrationElement('Status.io', <StatusIoIcon />, INTEGRATION_TYPES.types.statusIo)
    ]

    const deleteConfirmCallback = () => {
        dispatch(deleteIntegration(clickedIntegration || integrations?.find(item => item?.provider_id === checkedIntegrations[0])))
        setClickedIntegration(null)
    }

    const toggleNewIntegrationModal = (integration) => {
        if (integration) {
            setType(integration.type)
        }
        setIsNewIntegrationModalActive(!isNewIntegrationModalActive)
    }

    const toggleEditIntegrationModal = () => {
        setIsEditIntegrationModalActive(!isEditIntegrationModalActive)
    }

    const handleStatusUpdate = async(integration) => {
        setIsProgressing({
            [integration?.status ? text.disabled_text : text.enabled_text]: true
        })
        const isZapier = allIntegrationTypes.zapier.type === integration?.type
        const integrationId = integration?.integration_id || integration?.provider_id
        const data = {status: !integration?.status}
        await dispatch(updateIntegraitonStatus(integrationId, data, isZapier))
        await dispatch(getIntegrations(false))
        setIsProgressing({})
    }

    const getIntegrationStatus = integration => {
        return <span className="min-width-150">
            <span
                className={classNames('channel-status', {
                    'channel-enabled': !!integration?.status,
                    'channel-disabled': !integration?.status,
                    dark: isDarkMode
                })}>{integration?.status ? text.enabled_text : text.disabled_text}</span>
        </span>
    }

    const getIntegrationName = item => {
        return <span className="min-width-150">
            <span className="type">
                <span title={item.name}>{TextHelper.textLengthChecker(item.name, 17)}</span>
            </span>
        </span>
    }

    const getIntegrationType = item => {
        return <span className="min-width-150">
            <span className="type">
                {allIntegrationTypes[item?.type]?.icon}
                <span>{item.brand_name || item?.name}</span>
            </span>
        </span>
    }

    const getIntegrationId = integration => {
        return <span className='min-width-300'>{integration.provider_id || integration?.integration_id}</span>
    }

    const getIntegrationApiId = integration => {
        return <span className='min-width-150'>{integration.api_id || '-'}</span>
    }

    const getIntegrationApiKey = item => {
        return (
            <div className='flex-1 gap-1'>
                <span className='value'>
                    {item.api_key || '-'}
                </span>

                <div style={{marginLeft: 'auto'}}>
                    {Customer.isOwnTeam() && (
                        <Dropdown menuButton={<button className={classNames('table-action-btn', {
                            dark: isDarkMode
                        })}><HorizontalMoreIcon/></button>}>
                            {
                                item?.type !== allIntegrationTypes?.zapier?.type && (
                                    <MenuItem onClick={() => {
                                        setClickedIntegration(item)
                                        toggleEditIntegrationModal()
                                    }
                                    } disabled={isReadOnlyModeEnabled}>
                                        <span className="d-flex"><EditIcon stroke={colors.colorRed}/></span>
                                        <span>{text.edit}</span>
                                    </MenuItem>
                                )
                            }
                            <MenuItem
                                className="light-bg"
                                onClick={() => handleStatusUpdate(item)}
                                disabled={getDisableButtonDisabilityStatus(item) || isReadOnlyModeEnabled} >
                                <span>
                                    <PausedIcon/>
                                </span>
                                <span className="button-text">{text.disable}</span>
                            </MenuItem>
                            <MenuItem
                                className="light-bg"
                                onClick={() => handleStatusUpdate(item)}
                                disabled={getEnableButtonDisabilityStatus(item) || isReadOnlyModeEnabled} >
                                <span>
                                    <PlayIcon/>
                                </span>
                                <span className="button-text">{text.enable}</span>
                            </MenuItem>
                            <MenuItem className="danger" onClick={() => {
                                setClickedIntegration(item)
                                dispatch(setConfirmIsActive(true))
                            }
                            } disabled={isReadOnlyModeEnabled}>
                                <span className="d-flex"><TrashIcon stroke={colors.colorRed}/></span>
                                <span>{text.delete}</span>
                            </MenuItem>
                        </Dropdown>
                    )}
                </div>
            </div>
        )
    }

    const openDeleteIntegrationConfirm = () => {
        setClickedIntegration(null)
        dispatch(setConfirmIsActive(true))
    }

    const getEditButtonDisabledStatus = (integration = checkedIntegration) => {
        return !integration || 'provider_id' in integration && integration?.type === allIntegrationTypes?.zapier?.type
    }

    const getDisableButtonDisabilityStatus = (integration = checkedIntegration) => {
        return isProgressing.disabled || !integration || integration.status === false
    }

    const getEnableButtonDisabilityStatus = (integration = checkedIntegration) => {
        return isProgressing.enabled || !integration || integration.status === true
    }

    const generateIntegrationList = () => {
        return (
            <>
                <TeamSwitcher onChange={() => dispatch(getIntegrations(false))}/>
                <IntegrationTeamMenu/>
                {Customer.isOwnTeam() && (
                    <div className="search-filter-actions">
                        <div className="selected-actions">
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}
                            onClick={
                                toggleNewIntegrationModal
                            } disabled={isReadOnlyModeEnabled}>
                                <PlusIcon stroke={colors.colorMuted}/>
                                <span className="button-text">{text.new}</span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}  onClick={() => handleStatusUpdate(checkedIntegration)} disabled={getDisableButtonDisabilityStatus() || isReadOnlyModeEnabled} >
                                <span>
                                    {isProgressing?.disabled ? <ButtonLoader/> : <PausedIcon/>}
                                </span>
                                <span className="button-text">{text.disable}</span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}  onClick={() => handleStatusUpdate(checkedIntegration)} disabled={getEnableButtonDisabilityStatus() || isReadOnlyModeEnabled} >
                                <span>
                                    {isProgressing?.enabled ? <ButtonLoader/> : <PlayIcon/>}
                                </span>
                                <span className="button-text">{text.enable}</span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}
                            disabled={getEditButtonDisabledStatus() || isReadOnlyModeEnabled}
                            onClick={() => {
                                setClickedIntegration(null)
                                toggleEditIntegrationModal()
                            }}>
                                <EditIcon stroke={colors.colorMuted}/>
                                <span className="button-text">{text.edit}</span>
                            </ImgButton>
                            <ImgButton className={classNames('outline-red', {
                                'light-bg': !isDarkMode
                            })}
                            disabled={isDeleting || checkedIntegrations?.length !== 1 || isReadOnlyModeEnabled}
                            onClick={openDeleteIntegrationConfirm}>
                                <span><TrashIcon stroke={colors.colorRed}/></span>
                                <span className="button-text">{text.delete}</span>
                            </ImgButton>
                        </div>
                    </div>
                )}
                {integrations.length === 0 ?
                    <EmptyComponent
                        openModal={(integration) => toggleNewIntegrationModal(integration)}
                        zapierTypeIcons={zapierTypeIcons}
                        integrationOptions={integrationOptions}
                    />
                    : (
                        <div className="content-body">
                            <Table
                                soloCheck={true}
                                tableHeader={tableHeader}
                                tbodyData={tbodyData}
                                data={integrations}
                                identificator='provider_id'
                                inputName='integration'
                                isMultiCheckable={false}
                                hasCheckbox={Customer.isOwnTeam()}
                                selectedData={checkedIntegrations}
                                setSelectedData={data => dispatch(setCheckedIntegrations(data))}
                            />
                        </div>
                    )
                }
            </>
        )
    }

    integrations?.map(integration => {
        tbodyData.push([
            getIntegrationStatus(integration),
            getIntegrationName(integration),
            getIntegrationType(integration),
            getIntegrationId(integration),
            getIntegrationApiId(integration),
            getIntegrationApiKey(integration)
        ])
    })

    const getCurrentIntegrationCount = key => {
        return integrations?.filter(item => item?.type !== INTEGRATION_TYPES.types.zapier)?.length
    }

    const closeModal = (fetchIntegrations = false) => {
        if (fetchIntegrations) {
            dispatch(getIntegrations(false))
        }
        toggleNewIntegrationModal()
        setType(null)
    }

    const getClient = async() => {
        try {
            const {data} = await AuthService.getAuthClient(clientId, responseType, redirectUri, scopes)
            setClientData(data?.data?.client)
            setIsOauthModalActive(true)
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }

    useEffect(() => {
        dispatch(setCheckedIntegrations([]))
        dispatch(setIntegrations([]))
        dispatch(getIntegrations())
        if (clientId && responseType && scopes && redirectUri) {
            getClient()
        }
    }, [])

    useEffect(() => {
        setIsSelectedIntegrationZapier(type && type?.includes('zapier'))
    }, [type])

    return (
        <main className={classNames('main integrations', {
            dark: isDarkMode
        })}>
            <Confirm
                body={text.are_you_sure}
                callback={deleteConfirmCallback}
                showLoader={isDeleting}
            />
            <Modal
                contentClassName={(!isTypeSelected || (isIntegrationDisabled && !isSelectedIntegrationZapier)) && 'overflow-auto'}
                title={text.add_new_integration}
                closeModal={closeModal}
                isOpen={isNewIntegrationModalActive}
            >
                <AddIntegration
                    type={type}
                    isDarkMode={isDarkMode}
                    closePopup={closeModal}
                    getCurrentIntegrationCount={getCurrentIntegrationCount}
                    setType={setType}
                    isZapier={isSelectedIntegrationZapier}
                    zapierTypeIcons={zapierTypeIcons}
                    integrationOptions={integrationOptions}
                    isTypeSelected={isTypeSelected}
                    isIntegrationDisabled={isIntegrationDisabled}
                />
            </Modal>
            <Modal title={text.edit_integration} closeModal={() => setIsEditIntegrationModalActive(false)}
                isOpen={isEditIntegrationModalActive}>
                <EditIntegration
                    resetChecked={() => dispatch(setCheckedIntegrations([]))}
                    closePopup={() => setIsEditIntegrationModalActive(false)}
                    data={clickedIntegration || integrations?.find(item => item?.provider_id === checkedIntegrations[0])}/>
            </Modal>
            <Modal title={text.zapier_auth} closeModal={() => setIsOauthModalActive(false)}
                isOpen={isOauthModalActive}>
                <AuthClient
                    data={{clientData, redirectUri, clientId, responseType, state, scopes}}
                    closePopup={() => setIsOauthModalActive(false)}
                />
            </Modal>

            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{TextHelper.createSectionTitle(text.section)}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                {
                    isFetching ? <ContentLoader/> : (
                        <>
                            {generateIntegrationList()}
                        </>
                    )
                }
            </div>
            <Footer/>
        </main>
    )
}

export default Integrations
